export const audit = {
  gdpr: {
    title: 'GDPR',
    journaux: 'Journaux',
    search_tiers: 'Recherche Tiers',
    search_flux: 'Recherche Flux',
    title_tiers: 'Tiers',
    title_flux: 'Liste des Flux',
    alert_title:
      'Attention ! Ce traitement est irréversible. Le tiers et tous ces flux seront anonymisés. Désirez-vous continuer',
    anonym: 'Anonymisation',
    placeholder: {
      search: "Recherche d'un tiers par code, nom, IBAN",
    },
    column_tiers: {
      type: 'Type',
      code: 'Code',
      name: 'Nom',
      num_compte: 'N° de compte',
      devise: 'Devise',
      pays: 'Pays',
      date_modif: 'Date de modification',
    },
    column_flux: {
      num_lot: 'N° lot',
      num_remise: 'N° remise',
      flux: 'Flux',
      libele: 'Libellé',
      date_operation: "Date d'opération",
      state: 'Etat',
      beneficiary_name: 'Bénéficiaire',
      date_transmission: 'Date Transmission',
    },
  },
  auditConnexion: {
    table: {
      header: {
        title: 'Audit de connexion',
      },
      columns: {
        login: 'Login-Code API',
        date: 'Date',
        auth: 'Authentification',
        ipadresse: 'Adresse IP',
        platform: 'Plateforme',
        os: 'OS',
        navigator: 'Type navigateur',
        version: 'Version',
      },
    },
  },
  auditService: {
    table: {
      header: {
        title: 'Audit des services',
      },
      columns: {
        service: 'Services',
        state: 'Status',
        date: 'Date',
        libel: 'Libellé',
      },
    },
  },
  hashFile: {
    table: {
      header: {
        title: 'Fichiers importés',
      },
      confirm_to_delete:
        "Etes-vous sûr de vouloir supprimer ce Hash ? Attention, l'action sera irréversible",
      columns: {
        state: 'Status',
        file_name: 'Nom du fichier',
        value_hash: 'Hash',
        date: 'Date',
        type_file: 'Type de fichier',
        user: 'User Création',
        user_update: 'User Modification',
        date_update: 'Date de modification',
      },
    },
  },
  histoApi: {
    table: {
      header: {
        title: 'Appel API',
        modal_title: 'Visualisation du json',
      },
      columns: {
        key: 'Clé',
        method_name: 'Méthode',
        date: 'Date',
        code_retour: 'Code Retour HTTP',
        label_retour: 'Libellé Retour',
        param_appel: 'Paramètre Appel',
        body_retour: 'Body Retour',
        duree_appel: 'Durée Appel',
      },
      modal: {
        balise: 'Balise',
        value: 'Valeur',
      },
    },
  },
  histoFile: {
    table: {
      header: {
        title: 'Ordonnancement des opérations',
      },
      columns: {
        file_name: 'Nom fichier',
        code_compte: 'Code compte',
        code_society: 'Code société',
        code_flux: 'Code flux',
        amount_total: 'Montant total',
        nb_flux: 'Nombre flux',
        date_create: 'Date création lot',
        num_lot: 'N° Lot',
        user: 'User',
        currency: 'Devise',
        placeholder_flux: '- Flux -',
        placeholder_type_flux: '- Type flux -',
        state_detail: 'Etat détail',
      },
    },
  },
  trustedThird: {
    table: {
      header: {
        title: 'Liste des tiers de confiance',
      },
      columns: {
        currency: 'Devise',
        name: 'Nom',
        iban: 'IBAN',
        uptade_date: 'Date de modification',
      },
      modal_detail: {
        title: 'Détail de tiers de confiance',
        desactive_btn: 'Désactiver',
        message_confirm: 'Voulez-vous desactiver ce tiers',
        culumn: {
          average_amount: 'Montant moyen',
          sum_amount: 'Somme des montants',
          total_amount: 'Montant total',
          month_year: 'Année Mois',
          nb_operation: "Nombre d'opérations",
          amount_max: 'Montant maximum',
        },
      },
    },
  },
}

